import { Div, Icon, Label, useWindowSize } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { GROUP_TABS, useGroupScreen } from "./useGroupScreen";
import { GroupHeader } from "./GroupScreenHeader";
import GroupTab from "./GroupTab";
import { IPlayerGroup } from "@grassrootly/api";
import GroupGames from "../../components/group/group-tabs/group-games/GroupGames";
import GroupMembers from "../../components/group/group-tabs/group-members/GroupMembers";
import GroupStats from "../../components/group/group-tabs/group-stats/GroupStats";
import GroupTopPlays from "../../components/group/group-tabs/group-top-plays/GroupTopPlays";
import EditGroup from "../group/edit-group/EditGroup";
import GroupActionsMenu from "../../components/group/GroupActionsMenu";
import { Image } from "react-native";
import { images } from "../../layout/assets";
import moment from "moment";

export default function GroupScreenRM(props: MainStackScreenProps<"group">) {
  const { 
    group, 
    selectedTab, 
    groupTabs, 
    onTabSelected, 
    handleNavigationPress, 
    isEditing, 
    toggleEditing,
    isOwner,
    isMember,
    canLeaveGroup,
    onAddMember,
    onNewMatch,
    onEditGroup,
    onLeaveGroup,
    onJoinGroup
  } = useGroupScreen(props);
  const { width } = useWindowSize();

  return (
    <ScreenLayout
      header={{
        left: (
          <Icon classNames={["mb-{auto}", "mt-{8}"]} name="arrow_back_ios" size={24} onPress={handleNavigationPress} />
        ),
        right: group && (
          isEditing ? (
            <Icon
              name="close"
              size={24}
              onPress={toggleEditing}
              classNames={["mb-{5}", "mt-{8}"]}
            />
          ) : (
            <GroupActionsMenu
              isOwner={isOwner}
              isMember={isMember}
              canLeaveGroup={canLeaveGroup}
              onAddMember={onAddMember}
              onNewMatch={onNewMatch}
              onEditGroup={onEditGroup}
              onLeaveGroup={onLeaveGroup}
              onJoinGroup={onJoinGroup}
            />
          )
        ),
      }}
      headerPaddingWeb={false}
    >
      {/* Group Title Section */}
      {group && !isEditing && (
        <Div classNames={["mt-{70}", "mb-{24}", "flexRow", "alignItemsCenter"]}>
          <Image
            source={group.group_logo ? { uri: group.group_logo } : images.groupAvatar}
            style={{ width: 56, height: 56, borderRadius: 12, marginRight: 16 }}
            resizeMode="cover"
          />
          <Div classNames={["flex1"]}>
            <Label type="l1Bold" numberOfLines={2} classNames={["fontSize-{24}"]}>
              {group.name}
            </Label>
            <Label type="l3Regular" classNames={["colorSecondaryLight", "mt-{4}"]}>
              Active since {moment(group.created_at).format("DD.MM.YYYY")}
            </Label>
          </Div>
        </Div>
      )}

      {isEditing && group && (
        <Div classNames={["mt-{70}"]}>
          <EditGroup group={group} onEditFinished={toggleEditing} navigation={props.navigation} />
        </Div>
      )}

      {/* GROUP TABS */}
      {!isEditing && (
        <>
          <Div classNames={["mb-{20}"]}>
            <Div classNames={["flexRow"]}>
              {group &&
                groupTabs.map((x) => (
                  <GroupTab
                    key={x.alias}
                    alias={x.alias}
                    isActive={selectedTab === x.alias}
                    title={x.title}
                    onPress={onTabSelected}
                  />
                ))}
            </Div>
          </Div>

          {/* {selectedTab === GROUP_TABS.info.alias && group && <GroupDetails key={"details"} group={group as IPlayerGroup} navigation={props.navigation} fakePlayers={!!props.route.params.fakePlayers} />} */}
          {selectedTab === GROUP_TABS.info.alias && group && (
            <GroupStats key={"details"} group={group as IPlayerGroup} navigation={props.navigation} />
          )}
          {selectedTab === GROUP_TABS.matches.alias && group && (
            <GroupGames key={"games"} group={group as IPlayerGroup} navigation={props.navigation} />
          )}
          {selectedTab === GROUP_TABS.members.alias && group && (
            <GroupMembers key={"squad"} group={group as IPlayerGroup} navigation={props.navigation} />
          )}
          {selectedTab === GROUP_TABS.topPlays.alias && group && (
            <GroupTopPlays key={"topPlays"} group={group as IPlayerGroup} navigation={props.navigation} />
          )}
        </>
      )}
    </ScreenLayout>
  );
}
